const TripsHeader = () => {
  return <></>;
};
export default TripsHeader;
